import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';
import {
  FIRESTORE_TOKEN,
  FirestoreProvider,
  PLATFORM_TOKEN,
  PlatformProvider,
  USER_DATA_TOKEN,
  UserDataProvider
} from '../tokens';
import { UserModel } from '../interfaces';
import { ENV_CONFIG, EnvConfig } from '../env';
import { AppRoutes } from '../routes';
import { UserRoleEnum } from '@core-http';

export const blockWebVersionGuard = (): Observable<true | UrlTree> => {
  const router: Router = inject(Router);
  const platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);
  const userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);
  const firestoreProvider: FirestoreProvider = inject(FIRESTORE_TOKEN);
  const env: EnvConfig = inject(ENV_CONFIG);

  const isNativeRun: boolean = platformProvider.isNativeRun;

  const allowedUsers$: Observable<string[]> = firestoreProvider
    .documentSnapshot<{ users: string[] }>('block-web-view', 'allowed-users')
    .pipe(map((data: { users: string[] }) => data?.users ?? []));

  return combineLatest([userDataProvider.userData$, allowedUsers$]).pipe(
    map(([userData, allowedUsers]: [UserModel, string[]]) => {
      if (
        isNativeRun ||
        userData.role === UserRoleEnum.ADMIN ||
        allowedUsers.includes(userData.userId) ||
        !env.production
      )
        return true;
      return router.createUrlTree([AppRoutes.WEB_BLOCKED]);
    })
  );
};
